import { render } from "./CovidCert.vue?vue&type=template&id=eeece7ba"
import script from "./CovidCert.vue?vue&type=script&lang=js"
export * from "./CovidCert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__